import type { LoginErrorCode } from "@jipraks/shared";

export const authCopy = {
  login: {
    badge: "Masuk",
    title: "Masuk ke AI Class",
    description:
      "Gunakan akun Google Anda untuk mengakses kelas, workflow, dan invoice. Pakai email yang sama dengan saat Anda membeli.",
    googleButton: "Lanjutkan dengan Google",
    redirecting: "Mengarahkan ke Google…",
    terms: "Dengan masuk, Anda menyetujui syarat penggunaan AI Class.",
  },
  errors: {
    google_unavailable: "Login Google sedang tidak tersedia. Silakan coba beberapa saat lagi.",
    google_denied: "Login dibatalkan. Silakan coba lagi jika ingin masuk.",
    invalid_state: "Sesi login kedaluwarsa atau tidak valid. Silakan ulangi.",
    email_not_verified: "Email akun Google Anda belum terverifikasi.",
    login_failed: "Login gagal. Silakan coba lagi.",
  } satisfies Record<LoginErrorCode, string>,
  menu: {
    openMenu: "Buka menu akun",
    library: "Produk saya",
    invoices: "Invoice",
    switchToAdmin: "Beralih ke mode admin",
    switchToUser: "Beralih ke mode user",
    adminBadge: "Mode admin",
    signOut: "Keluar",
    signIn: "Masuk",
  },
} as const;
